import { render } from "./ChordSymbol.vue?vue&type=template&id=49cd25c9&scoped=true"
import script from "./ChordSymbol.vue?vue&type=script&lang=js"
export * from "./ChordSymbol.vue?vue&type=script&lang=js"

import "./ChordSymbol.vue?vue&type=style&index=0&id=49cd25c9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49cd25c9"

export default script